import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import MainToast from '@/components/common/Toast/MainToast';
import {
  QUICKBOOKS_ERROR_PARAM,
  XERO_ERROR_PARAM,
} from '@/components/project/Settings/components/Apps/accountingConnectCopy';
import { toast } from '@/reducers/toast/toast.actions';

export const ACCOUNTING_CONNECT_ERROR_TOAST_LABEL =
  'Something went wrong while connecting your accounting system. Nothing was connected — please try again from Settings > Apps.';

// OAuth callbacks that cannot attribute a project (unreadable state) land on
// the app root (`account#/?<provider>_connect_error=...`) where no project
// card exists to explain them. This surfaces a generic toast there and strips
// the params. Errors on a project page are owned by the QuickBooks/Xero cards
// and are left alone.
export const AccountingConnectErrorToast = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const params = new URLSearchParams(location.search);
  const connectError =
    params.get(QUICKBOOKS_ERROR_PARAM) ?? params.get(XERO_ERROR_PARAM);

  useEffect(() => {
    if (!connectError || location.pathname.startsWith('/projects/')) {
      return;
    }

    dispatch(toast(<MainToast label={ACCOUNTING_CONNECT_ERROR_TOAST_LABEL} />));

    const nextParams = new URLSearchParams(location.search);
    nextParams.delete(QUICKBOOKS_ERROR_PARAM);
    nextParams.delete(XERO_ERROR_PARAM);
    history.replace({
      search: nextParams.toString(),
    });
  }, [connectError, location.pathname, location.search, dispatch, history]);

  return null;
};
